import {announce} from '@github-ui/aria-live'
import {useEffect, useRef} from 'react'

export function useAnnounceOnMount<T extends HTMLElement>(message: string) {
  const ref = useRef<T>(null)

  // Announced from the element so it's heard inside the overlay dialog too.
  useEffect(() => {
    announce(message, {element: ref.current ?? undefined})
  }, [message])

  return ref
}
